import { connect } from 'react-redux';

import {
  getPageInfo,
  getCollectionFilter,
  getLocation,
  isSearchByPartner,
} from 'ha/pages/Search/selectors';
import SearchLocationTitle from 'ha/pages/Search/components/SearchLocationTitle';

const mapStateToProps = state => ({
  total: getPageInfo(state).total,
  canonicalCollection: getCollectionFilter(state),
  placeName: getLocation(state),
  isSearchByPartner: isSearchByPartner(state),
});

export default connect(mapStateToProps)(SearchLocationTitle);
